<template>
    <div class="container">
        <h2 class="profile-page-title">
            Проверка доступа к онлайн-классу
        </h2>

        <div class="row mt-2">
            <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{error}}</base-alert>
            </div>
            <div v-else class="col-12 text-center pt-4 pb-9 lesson-nearest">
                Вы будете перенаправлены в онлайн-класс для проверки доступа
            </div>
            <div class="col-12 text-center py-7" v-if="loading">
                <RippleLoader :color="'#5ab947'" :size="size" :duration="'1.5s'"/>
            </div>
        </div>
    </div>
</template>

<style>

    .lesson-go-item-title {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #32325d;
    }

    .lesson-no-nearest {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #8b8496;
    }

    .rasp-link {
        font-family: "Manrope Bold";
        color: white;
        text-decoration: underline;
    }

    .lesson-count-down {
        font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter";
        font-size: 60px;
        color: #f15b22;
        font-weight: bold;
    }

    .lesson-count-down-notice {
        color: #8b8496;
        font-size: 14px;
    }

    .lesson-count-down-header {
        font-size: 18px;
    }

    .lesson-count-down-header > span {
        color: #231c37;
        font-size: 20px;
    }

    .lesson-restricted {
        font-family: "Manrope Bold";
        font-size: 24px;
        color: #ed1c24;
    }

</style>


<script>
    import timetableApi from "../../../data/TimetablesApi";
    import {RippleLoader} from 'vue-spinners-css';
    import {isAuthenticated} from "../../../data/jwt.service";

    export default {
        name: "Go",
        components: {
            RippleLoader,
        },
        data() {
            return {
                duration: 4,
                size: 220,

                loading: true,
                error: null,
            }
        },

        async mounted() {
            if (isAuthenticated())
              this.go()
        },


        methods: {

            async go() {
                this.error = null
                this.loading = true
                const token = await timetableApi.fetchMyTokenAsync()
                if (token) {
                  window.location.href = 'https://online.poliglotiki.com/Account/LoginByToken?token=' + token.sessionToken
                      + '&redirectUrl=https://online.poliglotiki.com/student/lessons'
                } else {
                  this.loading = false
                  this.error = 'Ошибка! Попробуйте обновить страницу [2].'
                }
            },

            pad(num, size) {
                var s = num + "";
                while (s.length < size) s = "0" + s;
                return s;
            },
        },

    }
</script>

